export const CHART_PLUGINS = {
	NO_DATA_TO_DISPLAY: 'highcharts/modules/no-data-to-display',
	HIGHCHARTS_MORE: 'highcharts/highcharts-more',
	BOOST: 'highcharts/modules/boost',
	EXPORTING: 'highcharts/modules/exporting',
	STOCK: 'highcharts/modules/stock',
	OFFLINE_EXPORTING: 'highcharts/modules/offline-exporting',
	ACCESSIBILITY: 'highcharts/modules/accessibility',
};

export const FFT_UNITS = {
	HZ: 'hz',
	RPM: 'rpm',
};

export const BEARING_TYPES = {
	DE: 'DE',
	NDE: 'NDE'
};
